'use client';

import { cn } from '@/lib/cn';
import { useRef } from 'react';
import { useDateSegment } from 'react-aria';
import type {
  DateFieldState,
  DateSegment as IDateSegment,
} from 'react-stately';

interface DateSegmentProps {
  segment: IDateSegment;
  state: DateFieldState;
}

function DateSegment({ segment, state }: DateSegmentProps) {
  const ref = useRef<HTMLDivElement>(null);

  const {
    segmentProps: { ...segmentProps },
  } = useDateSegment(segment, state, ref);
  return (
    <div
      {...segmentProps}
      ref={ref}
      className={cn(
        'text-foreground focus:rounded-[2px] focus:bg-accent focus:text-accent-foreground focus:outline-hidden',
        segment.type !== 'literal' && 'px-px',
        segment.type === 'literal' && state.value == null
          ? 'text-muted-foreground'
          : '',
        segment.isPlaceholder ? 'text-muted-foreground/70' : 'px-px'
      )}
    >
      {segment.text}
    </div>
  );
}

export { DateSegment };
